module.exports = __webpack_public_path__ + "27111893_s.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/27111893_s.jpg
// module id = 268
// module chunks = 0